import { zoneTypeLabel } from '../../utils/inventoryLabels';
import { EMPTY_SLOT_FORM, SELLABLE_ZONES } from './slotsConstants';

/**
 * The form of a location, seeded from the one being edited.
 *
 * @param {object|null} slot - As the backend answers it; `null` for a new one.
 */
export const slotFormFrom = (slot) =>
  slot
    ? {
        name: slot.name || '',
        code: slot.code || '',
        zone_type: slot.zone_type,
        pick_rank: slot.pick_rank ?? 0,
        capacity: slot.capacity ?? 0,
        is_active: slot.is_active,
      }
    : { ...EMPTY_SLOT_FORM };

/**
 * What the form sends. The two numbers travel as numbers, and an emptied field
 * as zero — which is what both mean on the server: no order, no limit.
 */
export const buildSlotPayload = (form) => ({
  name: form.name.trim(),
  code: form.code.trim(),
  zone_type: form.zone_type,
  pick_rank: Number(form.pick_rank) || 0,
  capacity: Number(form.capacity) || 0,
  is_active: form.is_active,
});

/** What choosing a zone means for the stock put there. */
export const zoneHint = (zoneType) =>
  SELLABLE_ZONES.includes(zoneType)
    ? 'El stock guardado acá se puede reservar y vender.'
    : 'El stock guardado acá NO se puede reservar: entra, pero todavía no se vende.';

/**
 * How a location reads in a picker. The scannable code goes in when it adds
 * something, so typing or pasting it finds the location like its name does.
 */
export const slotOptionLabel = (slot) => {
  const code = slot.code && slot.code !== slot.name ? ` · ${slot.code}` : '';
  return `${slot.name}${code} — ${zoneTypeLabel(slot.zone_type)}`;
};

/**
 * The locations on screen as a sheet.
 *
 * @param {Array<object>} slots - As `slots/` sent them.
 * @returns {Array<object>}
 */
export const buildSlotsExportRows = (slots) =>
  slots.map((slot) => ({
    Bodega: slot.warehouse_name,
    Ubicación: slot.name,
    'Código de barras': slot.code || '',
    Zona: zoneTypeLabel(slot.zone_type),
    'Orden de recorrido': slot.pick_rank,
    Ocupación: Number(slot.occupancy),
    Capacidad: slot.capacity,
    'Uso %': slot.usage_pct === null ? 'sin límite' : slot.usage_pct,
    Estado: slot.is_active ? 'Activa' : 'De baja',
  }));

/** @param {object|null} warehouse - The warehouse in use, or `null` for all. */
export const slotsExportFileName = (warehouse) =>
  `ubicaciones-${warehouse ? warehouse.name : 'todas'}.xlsx`;
